export * from './LogoInstagramIcon';
export * from './LogoInstagramIcon16Light';
export * from './LogoInstagramIcon16Regular';
export * from './LogoInstagramIcon16Solid';
export * from './LogoInstagramIcon20Light';
export * from './LogoInstagramIcon20Regular';
export * from './LogoInstagramIcon20Solid';
export * from './LogoInstagramIcon24Regular';
export * from './LogoInstagramIcon24Solid';
export * from './LogoInstagramIcon32Regular';
export * from './LogoInstagramIcon64Regular';
